import thinkingdata from 'thinkingdata-browser';
import { ref } from 'vue';

// 埋点系统状态管理
export const trackingState = {
  isInitialized: ref(false),  // 是否初始化
  isUserLoggedIn: ref(false), // 是否登录
  initError: ref<string | null>(null), // 初始化错误
};


// 埋点配置
const createTrackingConfig = () => {
  return {
    appId: __TAID__,
    serverUrl: __TA_SERVER_URL__,
    showLog: import.meta.env.PROD ? false : false,
    enableCookie: true,
    persistence: 'localStorage',
    crossSubdomain: true,
    autoTrack: {
      //开启ta_page_show事件
      pageShow: true,
      //开启ta_page_hide事件
      pageHide: true,
     }
  };
};

/**
 * 初始化埋点系统
 */
const initializeTracking = () => {
  try {
    const config = createTrackingConfig();
    
    if (!config.appId || !config.serverUrl) {
      throw new Error('缺少必要的埋点配置：appId 或 serverUrl');
    }
    
    thinkingdata.init(config);
    trackingState.isInitialized.value = true;
    
    console.log('埋点系统初始化成功', { 
      appId: config.appId,
      serverUrl: config.serverUrl,
      env: import.meta.env.MODE 
    });
    
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : '未知错误';
    trackingState.initError.value = errorMessage;
    console.error('埋点系统初始化失败:', errorMessage);
    
    // 降级处理
    if (!trackingState.isInitialized.value) {
      console.warn('使用降级的埋点配置');
      thinkingdata.init({ appId: 'fallback', serverUrl: 'fallback' });
    }
  }
};

/**
 * 设置用户信息到埋点系统
 * @param userInfoOrId 用户ID或完整的用户信息对象
 */
export const setUserInfo = (user_id: string | number): boolean => {
  try {
    if (!trackingState.isInitialized.value) {
      console.warn('埋点系统未初始化，无法设置用户信息');
      return false;
    }

    const userId = user_id.toString();

    if (userId) {
      // 只登录，不设置额外属性
      thinkingdata.login(userId);
    }
    
    // 更新状态
    trackingState.isUserLoggedIn.value = true;
    
    console.log('埋点用户信息设置成功:', { userId });
    return true;
  } catch (error) {
    console.error('设置埋点用户信息失败:', error);
    return false;
  }
};

/**
 * 发送埋点事件
 * @param eventName 事件名称
 * @param properties 事件属性
 */
export const track = (eventName: string, properties?: Record<string, any>): boolean => {
  try {
    if (!trackingState.isInitialized.value) {
      console.warn('埋点系统未初始化，事件可能丢失:', eventName);
    }
    
    thinkingdata.track(eventName, properties || {});
    return true;
  } catch (error) {
    console.error('埋点发送失败:', { eventName, error });
    return false;
  }
};

/**
 * 设置用户属性
 * @param properties 用户属性
 */
export const setUserProperties = (properties: Record<string, any>): boolean => {
  try {
    if (!trackingState.isInitialized.value) {
      console.warn('埋点系统未初始化，无法设置用户属性');
      return false;
    }
    
    thinkingdata.setSuperProperties(properties);
    return true;
  } catch (error) {
    console.error('设置用户属性失败:', error);
    return false;
  }
};

/**
 * 用户登出时清理埋点信息
 */
export const clearUserInfo = (): boolean => {
  try {
    thinkingdata.logout();
    trackingState.isUserLoggedIn.value = false;
    console.log('埋点用户信息已清理');
    return true;
  } catch (error) {
    console.error('清理埋点用户信息失败:', error);
    return false;
  }
};

// 立即初始化
initializeTracking();

// 导出埋点实例
export const ta = thinkingdata; 